// Automatically generetated by @tempo/theme do not alter.
export const tokens = {
    breakpoints: {
        '2xl': '1800px',
        lg: '1200px',
        md: '1024px',
        sm: '724px',
        xl: '1535px'
    },
    fonts: {
        body: 'Inter, Arial, sans-serif',
        heading: '"Deezer Product", Tahoma, Arial, sans-serif',
        mono: 'SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace'
    },
    fontSizes: {
        xs: '0.75rem',
        sm: '0.875rem',
        md: '1rem',
        lg: '1.125rem',
        xl: '1.25rem',
        '2xl': '1.5rem',
        '3xl': '1.875rem',
        '4xl': '2.25rem',
        '5xl': '3rem',
        '6xl': '3.75rem',
        '7xl': '4.5rem',
        '8xl': '6rem',
        '9xl': '8rem'
    },
    fontWeights: {
        hairline: 100,
        thin: 200,
        light: 300,
        normal: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
        extrabold: 800,
        black: 900
    },
    letterSpacings: {
        tighter: '-0.05em',
        tight: '-0.025em',
        normal: '0',
        wide: '0.025em',
        wider: '0.05em',
        widest: '0.1em'
    },
    lineHeights: {
        '3': '.75rem',
        '4': '1rem',
        '5': '1.25rem',
        '6': '1.5rem',
        '7': '1.75rem',
        '8': '2rem',
        '9': '2.25rem',
        '10': '2.5rem',
        normal: 'normal',
        none: 1,
        shorter: 1.25,
        short: 1.375,
        base: 1.5,
        tall: 1.625,
        taller: '2'
    },
    colors: {
        brand: {
            algae: '#74e788',
            blue: '#4773eb',
            flame: '#ffce52',
            indigo: '#6849ff',
            jellyfish: '#30e0c6',
            lava: '#ef3841',
            magenta: '#d449d4',
            pink: '#e64796'
        },
        acid: {
            '50': '#ffffef',
            '60': '#feffce',
            '70': '#feffb6',
            '80': '#fdff94',
            '90': '#fdff80',
            '100': '#fcff60',
            '110': '#e5e857',
            '120': '#b3b544',
            '130': '#8b8c35',
            '140': '#6a6b28',
            '150': '#4a4a1c'
        },
        carrot: {
            '50': '#fffaef',
            '60': '#fef2d6',
            '70': '#fee2ae',
            '80': '#fece85',
            '90': '#feba67',
            '100': '#fe9935',
            '110': '#da7726',
            '120': '#b6581a',
            '130': '#933e10',
            '140': '#792b0a',
            '150': '#792b0a'
        },
        green: {
            '50': '#e8f5e9',
            '60': '#c8e6c9',
            '70': '#a5d6a7',
            '80': '#4dc977',
            '90': '#66bb6a',
            '100': '#00b23d',
            '110': '#43a047',
            '120': '#388e3c',
            '130': '#2e7d32',
            '140': '#1b5e20',
            '150': '#1b5e20'
        },
        neutral: {
            '10': '#fdfcfe',
            '20': '#f5f2f8',
            '30': '#ebe7ee',
            '40': '#e1dde4',
            '50': '#d1cfd3',
            '60': '#c2c0c4',
            '70': '#b4b1b6',
            '80': '#a9a6aa',
            '90': '#9a979c',
            '100': '#8c898e',
            '110': '#7d7b80',
            '120': '#6f6d71',
            '130': '#615e63',
            '140': '#555257',
            '150': '#464549',
            '160': '#3a393d',
            '170': '#29282d',
            '180': '#1b191f',
            '190': '#0f0d13',
            '200': '#000000',
            '00': '#ffffff'
        },
        orange: {
            '50': '#fff0ec',
            '60': '#ffd0c3',
            '70': '#ffb9a6',
            '80': '#ff997d',
            '90': '#ff8564',
            '100': '#ff673d',
            '110': '#e85e38',
            '120': '#b5492b',
            '130': '#8c3922',
            '140': '#6b2b1a',
            '150': '#461c11'
        },
        purple: {
            '50': '#f6ebff',
            '60': '#e2c1ff',
            '70': '#d4a3ff',
            '80': '#c17aff',
            '90': '#b560ff',
            '100': '#a238ff',
            '110': '#9333e8',
            '120': '#7328b5',
            '130': '#591f8c',
            '140': '#44186b',
            '150': '#32124e'
        },
        red: {
            '50': '#ffebee',
            '60': '#ffcdd2',
            '70': '#ef9a9a',
            '80': '#e57373',
            '90': '#ef5350',
            '100': '#f44336',
            '110': '#e53935',
            '120': '#d32f2f',
            '130': '#c62828',
            '140': '#b71c1c',
            '150': '#b71c1c'
        },
        teal: {
            '50': '#f5fefe',
            '60': '#defdfb',
            '70': '#cffcf9',
            '80': '#b9fbf7',
            '90': '#abfaf5',
            '100': '#96f9f3',
            '110': '#89e3dd',
            '120': '#6bb1ad',
            '130': '#538986',
            '140': '#3f6966',
            '150': '#2e4d4a'
        }
    },
    radii: {
        '2xs': '0.125rem',
        xs: '0.25rem',
        s: '0.5rem',
        m: '0.75rem',
        l: '1rem',
        rounded: '16rem'
    },
    semanticTokens: {
        colors: {
            'background.accent.onContent.default': '#00000066',
            'background.accent.onContent.disabled': '#00000029',
            'background.accent.onContent.hovered': '#0000008f',
            'background.accent.onContent.pressed': '#000000a3',
            'background.accent.onDark.default': 'neutral.10',
            'background.accent.onDark.disabled': 'neutral.30',
            'background.accent.onDark.hovered': 'neutral.20',
            'background.accent.onDark.pressed': 'neutral.30',
            'background.accent.onDark.selected': 'purple.50',
            'background.accent.onLight.default': 'neutral.190',
            'background.accent.onLight.disabled': 'neutral.170',
            'background.accent.onLight.hovered': 'neutral.180',
            'background.accent.onLight.pressed': 'neutral.170',
            'background.accent.onLight.selected': 'purple.150',
            'background.accent.primary.default': 'purple.100',
            'background.accent.primary.disabled': {
                default: 'neutral.40',
                _dark: 'neutral.160'
            },
            'background.accent.primary.hovered': {
                default: 'purple.110',
                _dark: 'purple.90'
            },
            'background.accent.primary.pressed': {
                default: 'purple.120',
                _dark: 'purple.80'
            },
            'background.brand.acid': 'acid.100',
            'background.brand.algae': 'brand.algae',
            'background.brand.black': 'neutral.180',
            'background.brand.blue': 'brand.blue',
            'background.brand.flame': 'brand.flame',
            'background.brand.indigo': 'brand.indigo',
            'background.brand.jellyfish': 'brand.jellyfish',
            'background.brand.lava': 'brand.lava',
            'background.brand.magenta': 'brand.magenta',
            'background.brand.orange': 'orange.100',
            'background.brand.pink': 'brand.pink',
            'background.brand.purple': 'purple.100',
            'background.brand.teal': 'teal.100',
            'background.brand.white': 'neutral.20',
            'background.feedback.error.default': 'red.100',
            'background.feedback.error.disabled': {
                default: 'neutral.40',
                _dark: 'neutral.160'
            },
            'background.feedback.error.hovered': {
                default: 'red.110',
                _dark: 'red.90'
            },
            'background.feedback.error.pressed': {
                default: 'red.120',
                _dark: 'red.80'
            },
            'background.feedback.success.default': 'green.100',
            'background.feedback.success.disabled': {
                default: 'neutral.40',
                _dark: 'neutral.160'
            },
            'background.feedback.success.hovered': {
                default: 'green.110',
                _dark: 'green.90'
            },
            'background.feedback.success.pressed': {
                default: 'green.120',
                _dark: 'green.80'
            },
            'background.feedback.warning.default': 'carrot.100',
            'background.feedback.warning.disabled': {
                default: 'neutral.40',
                _dark: 'neutral.160'
            },
            'background.feedback.warning.hovered': {
                default: 'carrot.110',
                _dark: 'carrot.90'
            },
            'background.feedback.warning.pressed': {
                default: 'carrot.120',
                _dark: 'carrot.80'
            },
            'background.neutral.inverse.default': {
                default: 'neutral.190',
                _dark: 'neutral.10'
            },
            'background.neutral.inverse.disabled': {
                default: 'neutral.170',
                _dark: 'neutral.30'
            },
            'background.neutral.inverse.hovered': {
                default: 'neutral.180',
                _dark: 'neutral.20'
            },
            'background.neutral.inverse.pressed': {
                default: 'neutral.170',
                _dark: 'neutral.30'
            },
            'background.neutral.inverse.selected': {
                default: 'purple.150',
                _dark: 'purple.50'
            },
            'background.neutral.primary.default': {
                default: 'neutral.10',
                _dark: 'neutral.190'
            },
            'background.neutral.primary.disabled': {
                default: 'neutral.30',
                _dark: 'neutral.170'
            },
            'background.neutral.primary.hovered': {
                default: 'neutral.20',
                _dark: 'neutral.180'
            },
            'background.neutral.primary.pressed': {
                default: 'neutral.30',
                _dark: 'neutral.170'
            },
            'background.neutral.primary.selected': {
                default: 'purple.50',
                _dark: 'purple.150'
            },
            'background.neutral.secondary.default': {
                default: 'neutral.20',
                _dark: 'neutral.180'
            },
            'background.neutral.secondary.disabled': {
                default: 'neutral.30',
                _dark: 'neutral.170'
            },
            'background.neutral.secondary.hovered': {
                default: 'neutral.30',
                _dark: 'neutral.170'
            },
            'background.neutral.secondary.pressed': {
                default: 'neutral.40',
                _dark: 'neutral.160'
            },
            'background.neutral.secondary.selected': {
                default: 'purple.50',
                _dark: 'purple.150'
            },
            'background.neutral.tertiary.default': {
                default: 'neutral.30',
                _dark: 'neutral.170'
            },
            'background.neutral.tertiary.disabled': {
                default: 'neutral.40',
                _dark: 'neutral.160'
            },
            'background.neutral.tertiary.hovered': {
                default: 'neutral.40',
                _dark: 'neutral.160'
            },
            'background.neutral.tertiary.pressed': {
                default: 'neutral.50',
                _dark: 'neutral.150'
            },
            'background.neutral.tertiary.selected': {
                default: 'purple.50',
                _dark: 'purple.150'
            },
            'border.accent.onContent.default': 'neutral.10',
            'border.accent.onContent.disabled': 'neutral.100',
            'border.accent.onContent.focused': 'purple.100',
            'border.accent.onContent.hovered': 'neutral.20',
            'border.accent.onContent.pressed': 'neutral.30',
            'border.accent.primary.default': 'purple.100',
            'border.accent.primary.disabled': {
                default: 'neutral.50',
                _dark: 'neutral.150'
            },
            'border.accent.primary.focused': {
                default: 'neutral.190',
                _dark: 'neutral.10'
            },
            'border.accent.primary.hovered': {
                default: 'purple.110',
                _dark: 'purple.90'
            },
            'border.accent.primary.pressed': {
                default: 'purple.130',
                _dark: 'purple.70'
            },
            'border.feedback.error.default': 'red.100',
            'border.feedback.error.disabled': {
                default: 'neutral.50',
                _dark: 'neutral.150'
            },
            'border.feedback.error.focused': 'purple.100',
            'border.feedback.error.hovered': 'red.100',
            'border.feedback.error.pressed': 'red.100',
            'border.feedback.success.default': 'green.100',
            'border.feedback.success.disabled': {
                default: 'neutral.50',
                _dark: 'neutral.150'
            },
            'border.feedback.success.focused': 'purple.100',
            'border.feedback.success.hovered': 'green.100',
            'border.feedback.success.pressed': 'green.100',
            'border.feedback.warning.default': 'carrot.100',
            'border.feedback.warning.disabled': {
                default: 'neutral.50',
                _dark: 'neutral.150'
            },
            'border.feedback.warning.focused': 'purple.100',
            'border.feedback.warning.hovered': 'carrot.100',
            'border.feedback.warning.pressed': 'carrot.100',
            'border.neutral.primary.default': {
                default: 'neutral.60',
                _dark: 'neutral.140'
            },
            'border.neutral.primary.disabled': {
                default: 'neutral.50',
                _dark: 'neutral.150'
            },
            'border.neutral.primary.focused': 'purple.100',
            'border.neutral.primary.hovered': {
                default: 'neutral.70',
                _dark: 'neutral.130'
            },
            'border.neutral.primary.pressed': {
                default: 'neutral.80',
                _dark: 'neutral.120'
            },
            'comp.coverDailyMix.color.background': 'red.50',
            'comp.coverDiscovery.color.background': 'red.60',
            'comp.coverFamilyMix.color.background': 'orange.60',
            'comp.coverGeneric.color.background': {
                default: 'orange.60',
                _dark: 'orange.90'
            },
            'comp.coverGeneric.color.icon': {
                default: 'orange.110',
                _dark: 'orange.120'
            },
            'comp.coverMonthly.color.background': 'purple.60',
            'comp.coverNewRelease.color.background': 'purple.70',
            'divider.neutral.primary.default': {
                default: 'neutral.40',
                _dark: 'neutral.160'
            },
            'divider.neutral.primary.disabled': {
                default: 'neutral.30',
                _dark: 'neutral.170'
            },
            'divider.neutral.primary.hovered': {
                default: 'neutral.50',
                _dark: 'neutral.150'
            },
            'divider.neutral.primary.pressed': {
                default: 'neutral.60',
                _dark: 'neutral.140'
            },
            'icon.accent.onDark.default': 'neutral.10',
            'icon.accent.onDark.disabled': 'neutral.120',
            'icon.accent.onDark.hovered': 'neutral.20',
            'icon.accent.onDark.pressed': 'neutral.30',
            'icon.accent.onDark.selected': 'purple.90',
            'icon.accent.onLight.default': 'neutral.190',
            'icon.accent.onLight.disabled': 'neutral.80',
            'icon.accent.onLight.hovered': 'neutral.180',
            'icon.accent.onLight.pressed': 'neutral.170',
            'icon.accent.onLight.selected': 'purple.110',
            'icon.accent.primary.default': {
                default: 'purple.110',
                _dark: 'purple.90'
            },
            'icon.accent.primary.disabled': {
                default: 'neutral.80',
                _dark: 'neutral.120'
            },
            'icon.accent.primary.hovered': {
                default: 'purple.120',
                _dark: 'purple.80'
            },
            'icon.accent.primary.pressed': {
                default: 'purple.130',
                _dark: 'purple.70'
            },
            'icon.feedback.error.default': 'red.100',
            'icon.feedback.error.disabled': {
                default: 'neutral.80',
                _dark: 'neutral.120'
            },
            'icon.feedback.error.hovered': {
                default: 'red.110',
                _dark: 'red.90'
            },
            'icon.feedback.error.pressed': {
                default: 'red.120',
                _dark: 'red.80'
            },
            'icon.feedback.success.default': 'green.100',
            'icon.feedback.success.disabled': {
                default: 'neutral.80',
                _dark: 'neutral.120'
            },
            'icon.feedback.success.hovered': {
                default: 'green.110',
                _dark: 'green.90'
            },
            'icon.feedback.success.pressed': {
                default: 'green.120',
                _dark: 'green.80'
            },
            'icon.feedback.warning.default': 'carrot.100',
            'icon.feedback.warning.disabled': {
                default: 'neutral.80',
                _dark: 'neutral.120'
            },
            'icon.feedback.warning.hovered': {
                default: 'carrot.110',
                _dark: 'carrot.90'
            },
            'icon.feedback.warning.pressed': {
                default: 'carrot.120',
                _dark: 'carrot.80'
            },
            'icon.neutral.inverse.default': {
                default: 'neutral.10',
                _dark: 'neutral.190'
            },
            'icon.neutral.inverse.disabled': {
                default: 'neutral.120',
                _dark: 'neutral.80'
            },
            'icon.neutral.inverse.hovered': {
                default: 'neutral.20',
                _dark: 'neutral.180'
            },
            'icon.neutral.inverse.pressed': {
                default: 'neutral.30',
                _dark: 'neutral.170'
            },
            'icon.neutral.inverse.selected': {
                default: 'purple.90',
                _dark: 'purple.110'
            },
            'icon.neutral.primary.default': {
                default: 'neutral.190',
                _dark: 'neutral.10'
            },
            'icon.neutral.primary.disabled': {
                default: 'neutral.80',
                _dark: 'neutral.120'
            },
            'icon.neutral.primary.hovered': {
                default: 'neutral.180',
                _dark: 'neutral.20'
            },
            'icon.neutral.primary.pressed': {
                default: 'neutral.170',
                _dark: 'neutral.30'
            },
            'icon.neutral.primary.selected': {
                default: 'purple.110',
                _dark: 'purple.90'
            },
            'icon.neutral.secondary.default': {
                default: 'neutral.120',
                _dark: 'neutral.80'
            },
            'icon.neutral.secondary.disabled': {
                default: 'neutral.70',
                _dark: 'neutral.130'
            },
            'icon.neutral.secondary.hovered': {
                default: 'neutral.130',
                _dark: 'neutral.70'
            },
            'icon.neutral.secondary.pressed': {
                default: 'neutral.140',
                _dark: 'neutral.60'
            },
            'icon.neutral.secondary.selected': {
                default: 'neutral.130',
                _dark: 'neutral.70'
            },
            'logo.symbol.accent': 'purple.100',
            'logo.symbol.onDark': 'neutral.00',
            'logo.symbol.onLight': 'neutral.200',
            'logo.wordmark.primary': {
                default: 'neutral.200',
                _dark: 'neutral.00'
            },
            'logo.wordmark.onDark': 'neutral.00',
            'logo.wordmark.onLight': 'neutral.200',
            'text.accent.onDark.default': 'neutral.10',
            'text.accent.onDark.disabled': 'neutral.120',
            'text.accent.onDark.hovered': 'neutral.20',
            'text.accent.onDark.pressed': 'neutral.30',
            'text.accent.onDark.selected': 'purple.90',
            'text.accent.onLight.default': 'neutral.190',
            'text.accent.onLight.disabled': 'neutral.80',
            'text.accent.onLight.hovered': 'neutral.180',
            'text.accent.onLight.pressed': 'neutral.170',
            'text.accent.onLight.selected': 'purple.110',
            'text.accent.primary.default': {
                default: 'purple.110',
                _dark: 'purple.90'
            },
            'text.accent.primary.disabled': {
                default: 'neutral.80',
                _dark: 'neutral.120'
            },
            'text.accent.primary.hovered': {
                default: 'purple.120',
                _dark: 'purple.80'
            },
            'text.accent.primary.pressed': {
                default: 'purple.130',
                _dark: 'purple.70'
            },
            'text.feedback.error.default': 'red.100',
            'text.feedback.error.disabled': {
                default: 'neutral.80',
                _dark: 'neutral.120'
            },
            'text.feedback.error.hovered': {
                default: 'red.110',
                _dark: 'red.90'
            },
            'text.feedback.error.pressed': {
                default: 'red.120',
                _dark: 'red.80'
            },
            'text.feedback.success.default': 'green.100',
            'text.feedback.success.disabled': {
                default: 'neutral.80',
                _dark: 'neutral.120'
            },
            'text.feedback.success.hovered': {
                default: 'green.110',
                _dark: 'green.90'
            },
            'text.feedback.success.pressed': {
                default: 'green.120',
                _dark: 'green.80'
            },
            'text.feedback.warning.default': 'carrot.100',
            'text.feedback.warning.disabled': {
                default: 'neutral.80',
                _dark: 'neutral.120'
            },
            'text.feedback.warning.hovered': {
                default: 'carrot.110',
                _dark: 'carrot.90'
            },
            'text.feedback.warning.pressed': {
                default: 'carrot.120',
                _dark: 'carrot.80'
            },
            'text.neutral.inverse.default': {
                default: 'neutral.10',
                _dark: 'neutral.190'
            },
            'text.neutral.inverse.disabled': {
                default: 'neutral.120',
                _dark: 'neutral.80'
            },
            'text.neutral.inverse.hovered': {
                default: 'neutral.20',
                _dark: 'neutral.180'
            },
            'text.neutral.inverse.pressed': {
                default: 'neutral.30',
                _dark: 'neutral.170'
            },
            'text.neutral.inverse.selected': {
                default: 'purple.90',
                _dark: 'purple.110'
            },
            'text.neutral.primary.default': {
                default: 'neutral.190',
                _dark: 'neutral.10'
            },
            'text.neutral.primary.disabled': {
                default: 'neutral.80',
                _dark: 'neutral.120'
            },
            'text.neutral.primary.hovered': {
                default: 'neutral.180',
                _dark: 'neutral.20'
            },
            'text.neutral.primary.pressed': {
                default: 'neutral.170',
                _dark: 'neutral.30'
            },
            'text.neutral.primary.selected': {
                default: 'purple.110',
                _dark: 'purple.90'
            },
            'text.neutral.secondary.default': {
                default: 'neutral.120',
                _dark: 'neutral.80'
            },
            'text.neutral.secondary.disabled': {
                default: 'neutral.70',
                _dark: 'neutral.130'
            },
            'text.neutral.secondary.hovered': {
                default: 'neutral.130',
                _dark: 'neutral.70'
            },
            'text.neutral.secondary.pressed': {
                default: 'neutral.140',
                _dark: 'neutral.60'
            },
            'text.neutral.secondary.selected': {
                default: 'neutral.130',
                _dark: 'neutral.70'
            }
        },
        sizes: {
            'size.xs': 'x1',
            'size.s': 'x1_5',
            'size.m': 'x2',
            'size.l': 'x2_5',
            'size.xl': 'x3',
            'size.2xl': 'x4',
            'size.3xl': 'x8',
            'size.4xl': 'x16',
            'spacing.2xs': 'x0_125',
            'spacing.xs': 'x0_250',
            'spacing.s': 'x0_5',
            'spacing.m': 'x0_75',
            'spacing.l': 'x1',
            'spacing.xl': 'x1_5',
            'spacing.2xl': 'x2',
            'spacing.3xl': 'x3',
            'icon.xs': '0.75rem',
            'icon.s': '1rem',
            'icon.m': '1.5rem',
            'icon.l': '2rem'
        },
        space: {
            'size.xs': 'x1',
            'size.s': 'x1_5',
            'size.m': 'x2',
            'size.l': 'x2_5',
            'size.xl': 'x3',
            'size.2xl': 'x4',
            'size.3xl': 'x8',
            'size.4xl': 'x16',
            'spacing.2xs': 'x0_125',
            'spacing.xs': 'x0_250',
            'spacing.s': 'x0_5',
            'spacing.m': 'x0_75',
            'spacing.l': 'x1',
            'spacing.xl': 'x1_5',
            'spacing.2xl': 'x2',
            'spacing.3xl': 'x3',
            'icon.xs': '0.75rem',
            'icon.s': '1rem',
            'icon.m': '1.5rem',
            'icon.l': '2rem'
        }
    },
    scales: {
        null: '0rem',
        x0_0625: '0.0625rem',
        x0_125: '0.125rem',
        x0_250: '0.25rem',
        x0_5: '0.5rem',
        x0_75: '0.75rem',
        x1: '1rem',
        x1_5: '1.5rem',
        x2: '2rem',
        x2_5: '2.5rem',
        x3: '3rem',
        x4: '4rem',
        x5: '5rem',
        x6: '6rem',
        x8: '8rem',
        x16: '16rem',
        x32: '32rem'
    },
    sizes: {
        null: '0rem',
        x0_0625: '0.0625rem',
        x0_125: '0.125rem',
        x0_250: '0.25rem',
        x0_5: '0.5rem',
        x0_75: '0.75rem',
        x1: '1rem',
        x1_5: '1.5rem',
        x2: '2rem',
        x2_5: '2.5rem',
        x3: '3rem',
        x4: '4rem',
        x5: '5rem',
        x6: '6rem',
        x8: '8rem',
        x16: '16rem',
        x32: '32rem'
    },
    space: {
        null: '0rem',
        x0_0625: '0.0625rem',
        x0_125: '0.125rem',
        x0_250: '0.25rem',
        x0_5: '0.5rem',
        x0_75: '0.75rem',
        x1: '1rem',
        x1_5: '1.5rem',
        x2: '2rem',
        x2_5: '2.5rem',
        x3: '3rem',
        x4: '4rem',
        x5: '5rem',
        x6: '6rem',
        x8: '8rem',
        x16: '16rem',
        x32: '32rem'
    }
};

//# sourceMappingURL=chakra.js.map